import { useRef, useState } from 'react';
import clsx from 'clsx';
import GrayButton from 'ui/GrayButton/GrayButton';
import Icon from 'ui/Icon/Icon';
import DaoIcon from 'ui/SVG/DaoIcon';
import PeopleIcon from 'ui/SVG/PeopleIcon';
import Title from 'ui/Title/Title';
import ProductVideo from './ProductVideo';
import './Product.scss';
import './ProductAnim.scss';

enum UserRole {
  ADMIN,
  CONTRIBUTOR,
}

const Product: React.FC = () => {
  const adminRef = useRef<HTMLVideoElement>(null);
  const contributorRef = useRef<HTMLVideoElement>(null);
  const [start, setStart] = useState(true);
  const [role, setRole] = useState<UserRole>(UserRole.ADMIN);

  const handleRole = (role: UserRole) => {
    setRole(role);
    setStart(false);
  };

  return (
    <div className="product section" id="product">
      <div className="container product__container">
        <Title className="product__title">
          Hover to learn about the product
        </Title>
        <div className="product__controls">
          <GrayButton
            className={clsx('product__btn product__btn_admin', {
              '--active': role === UserRole.ADMIN,
              '--start': start,
            })}
            onMouseEnter={() => handleRole(UserRole.ADMIN)}
          >
            <Icon className="product__btn-icon">
              <DaoIcon />
            </Icon>
            <span>DAO Admin</span>
          </GrayButton>
          <GrayButton
            className={clsx('product__btn product__btn_contributor', {
              '--active': role === UserRole.CONTRIBUTOR,
              '--start': start,
            })}
            onMouseEnter={() => handleRole(UserRole.CONTRIBUTOR)}
          >
            <Icon className="product__btn-icon">
              <PeopleIcon />
            </Icon>
            <span>DAO Contributor</span>
          </GrayButton>
        </div>
        {/* <p className="ui-text product__text">
          Samudai organizes information and provides tools to enable seamless
          coordination across the DAO ecosystem
        </p> */}
        <div className="product__media">
          <div className="product__video">
            <ProductVideo
              active={role === UserRole.ADMIN}
              src={require('media/admin_dao.mp4')}
            />
            <ProductVideo
              active={role === UserRole.CONTRIBUTOR}
              src={require('media/contributor_dao.mp4')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
